import React, { useState } from "react";
import { Container, Label, Input, FormGroup, FormFeedback, Button, Spinner } from "reactstrap";

import rawHtml         from 'html-react-parser';
import { Image }       from 'react-feather';

import Msg             from "~/components/messages";
import ImageUploader   from '~/components/imageUpload';
import validationGroup from "~/components/validation";
import formData        from '~/components/jsonFormData';

import Task, { TaskType, TaskRewardStatusType, TextInputType } from "~/services/tasks";


const TaskDetails = ({setOverlayOpen, selectedTask, setReload})=> {

  const [claim   , setClaim]   = useState(Task.defaultValue);
  const [loading , setLoading] = useState(false);
  const [errors  , setErrors]  = useState({});
  const validation = validationGroup("Tasks");

  const changeProp  = (key, val)=> setClaim((prev)=> ({...prev, [key]: val}));

  const hasErrors = ()=> {

    const errorsValidator = {
      [TaskType.TEXT]         : { ...validation("input", claim.input, {type: selectedTask.inputType, id: selectedTask.id}) },
      [TaskType.PICTURE]      : { ...validation("file",  claim.file) },
      [TaskType.TEXT_PICTURE] : { ...validation("input", claim.input, {type: selectedTask.inputType, id: selectedTask.id}), ...validation("file", claim.file) },
    };

    const errorList = errorsValidator[selectedTask.type] || {};
    setErrors(errorList);

    return Boolean(Object.values(errorList).length);
  };

  const submit = async (e)=> {

    e.preventDefault();
    if(hasErrors()) return;

    setLoading(true);
    Task.submit(selectedTask.id, formData(claim))
      .then(()=> {
        setOverlayOpen(false);
        setReload();
        Msg.general("Task submitted");
      }).catch(err =>{
        selectedTask.id === 17 && Msg.emptyCode(err.data.error);
      })
      .finally(()=>{
        setLoading(false);
      });
  };

  let unsubmitted = selectedTask.status === TaskRewardStatusType.NEW;

  return (
    <Container className="task-info">
      <p className="m-b-5"><strong> Info </strong> </p>
      <div className="info">
        { rawHtml(selectedTask.description || '') }
      </div>
      <p className="points"> Points: { selectedTask.status === TaskRewardStatusType.REJECTED ? 0 :  selectedTask.points } </p>

      { selectedTask.status === TaskRewardStatusType.NEW &&
        <div>
          {(selectedTask.type === TaskType.PICTURE || selectedTask.type === TaskType.TEXT_PICTURE) &&
            <FormGroup>
              <Label>{ selectedTask.labels.picture || "Upload Picture" }</Label>
              <ImageUploader
                className={`${errors.file ? 'is-invalid' : ''}`}
                withIcon={false}
                withLabel={false}
                withPreview={true}
                singleImage={true}
                imgExtension={[".jpg", ".jpeg", ".png", ".gif"]}
                buttonText={<Image style={{position:'relative', top: 3, right: 1}} />}
                onChange={(files)=> changeProp('file', files[0])}>
              </ImageUploader>

              { errors.file && <FormFeedback> {errors.file} </FormFeedback> }
            </FormGroup>}

          {(selectedTask.type === TaskType.TEXT || selectedTask.type === TaskType.TEXT_PICTURE) &&
            <FormGroup>
              <Label className="col-form-label pt-0">{ selectedTask.labels.text || "Insert Your Details" }</Label>
              <Input type={selectedTask.inputType === TextInputType.TEXT ? 'text' : "url"}
                onChange={(e)=> changeProp("input", e.target.value)}
                className={`${errors.input ? 'is-invalid' : ''}`}
                placeholder={ selectedTask.labels.text || "Insert Your Details" }
                value={claim.input}
                />
              { errors.input && <FormFeedback> {errors.input} </FormFeedback> }
            </FormGroup>
          }
        </div> }

      { selectedTask.status === TaskRewardStatusType.PENDING &&
        <p className="m-b-5 text-info"><strong>Your submit for this task is being processed!</strong> </p>
      }

      { selectedTask.status === TaskRewardStatusType.ACCEPTED &&
        <p className="m-b-5 text-success"><strong>You completed this task! </strong> </p>
      }

      { selectedTask.status === TaskRewardStatusType.REJECTED &&
        <p className="m-b-5 text-danger"><strong> Your submission was rejected! </strong> </p>
      }

      <div className="d-flex" style={unsubmitted ? {justifyContent: 'space-between'} : {justifyContent: 'center'}}>
        <Button color="danger" onClick={()=> setOverlayOpen(false)}> Cancel </Button>

        { unsubmitted && <Button color="primary" onClick={submit} disabled={loading}>
          { loading ? <Spinner size="sm" /> : "Submit" }
        </Button> }
      </div>

    </Container>
  );
}

export default TaskDetails;
